import { baseThemeValues } from 'constants/common';

export const popoverTheme = {
  bg: 'palette.surface.3',
  borderColor: 'palette.transparent',
  borderRadius: '8px',
  borderWidth: '0px',
  boxShadow: 'palette.black:0.5',
  fontFamily: baseThemeValues.inherit,
  fontSize: '16px',
  fontWeight: 400,
  text: 'palette.tertiary.70',
};
